import React, {useState} from 'react';
import dateFormat from 'dateformat';

import * as S from './SearchBlockUI.styles';

import CalendarBlock from '../CalendarBlock/CalendarBlockv2';

import PaxWidget from './../PaxWidget/PaxWidget';

import HomePageAutosuggest from './../../SRP/Autosuggests/HomePageAutosuggest/HomePageAutosuggest';

import useSearchWidgetUI from '../../../../../shared/hooks/useSearchWidgetUI';
import {splitRoomString} from '../../../../../shared/utils/room-string-utils';

const SearchBlockUI = ({
  updateQueryCaller,
  autosuggestHandler,
  country,
  checkin,
  checkout,
  partner,
  roomString,
  destination,
}) => {
  const [displayOverlay, setDisplayOverlay] = useState(false);

  const {
    calendarBlockRef,
    paxWidgetBlockRef,
    isPaxWidgetVisible,
    calendarMode,
    closeCalendar,
    setCalendarMode,
    togglePaxWidget,
  } = useSearchWidgetUI();

  const isCalendarVisible = calendarMode !== '';

  const [roomCount, paxCount, childCount] = splitRoomString(roomString);

  return (
    <S.SearchWidgetMainWrap>
      
      <S.SearchWidgetAutoSuggest>
          <S.AutoSuggestTextWrap isactive={displayOverlay ? 'true' : 'false'}>
            <S.AutoSuggestHeadText>CITY / HOTEL / AREA / BUILDING</S.AutoSuggestHeadText>
              <HomePageAutosuggest
                initialInputValue={destination.n}
                onItemSelection={changes => {
                  autosuggestHandler(changes);
                }}
                toggleOverlay={setDisplayOverlay}
                partner={partner}
                onClick={() => {}}
              />
            <S.AutoSuggestInfoText>{country}</S.AutoSuggestInfoText>
          </S.AutoSuggestTextWrap>
      </S.SearchWidgetAutoSuggest>

      <S.SearchWidgetDateWrap>
        <S.AutoSuggestTextWrap onClick={() => {
          setCalendarMode('checkin');
          if (isPaxWidgetVisible) togglePaxWidget(false);
        }} inputColor="rebeccapurple">
            <S.AutoSuggestHeadText>CHECK-IN</S.AutoSuggestHeadText>
            <S.AutoSuggestCalText>{dateFormat(checkin.date, 'dd')} <span>{dateFormat(checkin.date, 'mmm\'yy')}</span></S.AutoSuggestCalText>
            <S.AutoSuggestInfoText>{dateFormat(checkin.date, 'dddd')}</S.AutoSuggestInfoText>
        </S.AutoSuggestTextWrap>
        {(calendarMode === 'checkin' && (
          <CalendarBlock
            ref={calendarBlockRef}
            isCheckinMode={calendarMode === 'checkin'}
            isCheckoutMode={false}
            onSelection={() => {
              setCalendarMode('checkout');
            }}
            updateQueryCaller={updateQueryCaller}
            checkin={checkin}
            checkout={checkout}
          />
        )) ||
          null}
      </S.SearchWidgetDateWrap>

      <S.SearchWidgetDateWrap>
        <S.AutoSuggestTextWrap onClick={() => {
          setCalendarMode('checkout');
          if (isPaxWidgetVisible) togglePaxWidget(false);
        }}>
            <S.AutoSuggestHeadText>CHECK-OUT</S.AutoSuggestHeadText>
            <S.AutoSuggestCalText>{dateFormat(checkout.date, 'dd')} <span>{dateFormat(checkout.date, 'mmm\'yy')}</span></S.AutoSuggestCalText>
            <S.AutoSuggestInfoText>{dateFormat(checkout.date, 'dddd')}</S.AutoSuggestInfoText>
        </S.AutoSuggestTextWrap>
        {(calendarMode === 'checkout' && (
          <CalendarBlock
            ref={calendarBlockRef}
            isCheckinMode={false}
            isCheckoutMode={calendarMode === 'checkout'}
            onSelection={closeCalendar}
            updateQueryCaller={updateQueryCaller}
            checkin={checkin}
            checkout={checkout}
          />
        )) ||
          null}
      </S.SearchWidgetDateWrap>

      <S.SearchWidgetPaxWrap onClick={() => {
        if (isCalendarVisible) closeCalendar();

        if (!isPaxWidgetVisible) {
          togglePaxWidget(true);
        }
      }}>
        <S.AutoSuggestTextWrap>
          <S.AutoSuggestHeadText>ROOMS & GUESTS</S.AutoSuggestHeadText>

          <S.AutoSuggestCalText>
            {roomCount} <span>{roomCount > 1 ? 'Rooms ' : 'Room'} </span>
            {paxCount} <span>{paxCount > 1 ? 'Adults' : 'Adult'} </span>
            {childCount} <span>{childCount > 1 ? 'Children' : 'Child'} </span>
          </S.AutoSuggestCalText>

        </S.AutoSuggestTextWrap>
        {(isPaxWidgetVisible && (
          <PaxWidget
            ref={paxWidgetBlockRef}
            togglePaxWidget={togglePaxWidget}
            updateQueryCaller={updateQueryCaller}
            roomString={roomString}
            updateSearch={() => {}}
          />
        )) ||
          null}

      </S.SearchWidgetPaxWrap>

    </S.SearchWidgetMainWrap>
  );
};

export default SearchBlockUI;
